import apiClient from '../client';
import type { User } from '../../../types';

// Admin dashboard response type
export interface AdminDashboardData {
  storeId: number;
  todayDeposits: number;
  todayUsages: number;
  todayPayments: number;
  registeredCustomers: number;
  totalBalance: number;
  date: string;
}

// User create/update types
export interface UserCreateInput {
  storeId: number;
  userId: string;
  name: string;
  password: string;
  role: 'admin' | 'user';
  isActive?: boolean;
}

export interface UserUpdateInput {
  name?: string;
  password?: string;
  role?: 'admin' | 'user';
  isActive?: boolean;
}

export const adminApi = {
  // Get admin dashboard data
  getDashboard: async (targetDate?: string): Promise<AdminDashboardData> => {
    const params = targetDate ? `?target_date=${targetDate}` : '';
    return apiClient.get<AdminDashboardData>(`/admin/dashboard${params}`);
  },

  // Get users list
  getUsers: async (includeInactive = false): Promise<User[]> => {
    const params = `?include_inactive=${includeInactive}`;
    return apiClient.get<User[]>(`/admin/users${params}`);
  },

  // Create new user
  createUser: async (userData: UserCreateInput): Promise<User> => {
    return apiClient.post<User>('/admin/users', userData);
  },

  // Update user
  updateUser: async (userId: number, userData: UserUpdateInput): Promise<User> => {
    return apiClient.put<User>(`/admin/users/${userId}`, userData);
  },

  // Delete (deactivate) user
  deleteUser: async (userId: number): Promise<void> => {
    return apiClient.delete<void>(`/admin/users/${userId}`);
  },

  // Toggle user active status
  toggleUserActive: async (userId: number): Promise<User> => {
    return apiClient.put<User>(`/admin/users/${userId}/toggle-active`);
  }
};
